import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import cs from 'classnames';
import { addYears, getYear, setYear, subYears } from 'date-fns';
import range from 'lodash/range';
import Cell from './Cell';
import ViewHeader from './ViewHeader';
import { isDisabled } from './util';
export const YearSelector = (props)=>{
    const { date, minDate, maxDate, setDate, prevView } = props;
    const start = subYears(date, 5);
    const end = addYears(date, 6);
    const setDateRef = useRef(setDate);
    const prevViewRef = useRef(prevView);
    setDateRef.current = setDate;
    prevViewRef.current = prevView;
    useEffect(()=>{
        const selectYear = (day)=>{
            const disabled = isDisabled(day, minDate, maxDate);
            if (!disabled) {
                setDateRef.current(day);
            }
        };
        const keydownHandler = (e)=>{
            switch(e.key){
                case 'ArrowRight':
                    selectYear(addYears(date, 1));
                    e.preventDefault();
                    break;
                case 'ArrowLeft':
                    selectYear(addYears(date, -1));
                    e.preventDefault();
                    break;
                case 'ArrowUp':
                    selectYear(addYears(date, -3));
                    e.preventDefault();
                    break;
                case 'ArrowDown':
                    selectYear(addYears(date, 3));
                    e.preventDefault();
                    break;
                case 'Enter':
                    prevViewRef.current();
                    e.preventDefault();
                    break;
            }
        };
        document.addEventListener('keydown', keydownHandler);
        return ()=>{
            document.removeEventListener('keydown', keydownHandler);
        };
    }, [
        date,
        minDate,
        maxDate
    ]);
    const [yearRange, setYearRange] = useState([]);
    const currYear = getYear(date);
    useEffect(()=>{
        if (!yearRange.includes(currYear)) {
            setYearRange(range(getYear(start), getYear(end) + 1));
        }
    }, [
        currYear,
        end,
        start,
        yearRange
    ]);
    const years = yearRange.map((year)=>{
        const minOk = !minDate || getYear(minDate) <= year;
        const maxOk = !maxDate || getYear(maxDate) >= year;
        return /*#__PURE__*/ _jsx(Cell, {
            value: year.toString(),
            classes: cs({
                year: true,
                disabled: !minOk || !maxOk,
                current: year === currYear
            }),
            onClick: ()=>{
                if (minOk && maxOk) {
                    const newDate = setYear(date, year);
                    setDate(newDate);
                    prevViewRef.current();
                }
            }
        }, year);
    });
    const next = ()=>setDate(addYears(date, 10));
    const prev = ()=>setDate(subYears(date, 10));
    const currentDate = `${getYear(start)}-${getYear(end)}`;
    return /*#__PURE__*/ _jsxs("div", {
        className: "years-view",
        children: [
            /*#__PURE__*/ _jsx(ViewHeader, {
                data: currentDate,
                next: next,
                prev: prev
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "years",
                children: years
            })
        ]
    });
};
